import React, { useState, useEffect } from 'react'
import Riepilogo from './riepilogo'
import RiepilogoCard from './riepilogoCard'
import RiepilogoCardCosti from './riepilogoCardCosti'
import RiepilogoCardFotoDescrizione from './riepilogoCardFotoDescrizione'
import RiepilogoCardDettagli from './riepilogoCardDettagli'
import { Row, message } from 'antd'
import { getAnnuncio } from '../utils/mapping'
import axios from 'axios'
import { localStorageVariables } from '../assets/constants'
import { RiepilogoButton } from './buttons'
import { useParams } from 'react-router-dom'
import TagManager from 'react-gtm-module'
import _ from 'lodash'

const key = 'creation'

const tagManagerArgs = (userId) => {
  return {
    dataLayer: {
      userId,
      event: 'uploadListing'
    },
    dataLayerName: 'dataLayer'
  }
}

const RiepilogoCosti = (props) => {
  const [published, setPublished] = useState(null)
  const [loading, setLoading] = useState(false)
  const { propertyId: _propertyId, draftId } = useParams()
  const propertyId = _propertyId || draftId
  useEffect(() => {
    if (published) {
      _.each(localStorageVariables, (item) =>
        window.localStorage.removeItem(item)
      )
      window.location.href = `${process.env.REACT_APP_URL}/it/affitto/${published.id}`
    }
  }, [published])
  const onClickAnnuncio = async () => {
    const obj = getAnnuncio({
      formValue: {
        ...props.formValue,
        images: _.get(props.formValue, 'images', [])
      }
    })
    try {
      setLoading(true)
      message.loading({
        content: "Pubblicazione dell'annuncio in corso...",
        key,
        duration: 1000
      })
      if (!_propertyId) {
        const { data: result } = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/propertylisting/create`,
          {
            ...obj,
            isDraft: false,
            draftChange: true
          }
        )
        const tagManagerArguments = tagManagerArgs(props.formValue.user_idFk)
        TagManager.dataLayer(tagManagerArguments)
        message
          .success({
            content:
              'Annuncio creato con successo, ti stiamo portando al tuo annuncio',
            duration: 3,
            key
          })
          .then((e) => {
            setPublished(_.get(result.data, '[0]'))
          })
      } else {
        message
          .success({
            content:
              'Annuncio modificato con successo, ti stiamo portando al tuo annuncio',
            duration: 3,
            key
          })
          .then((e) => {
            setPublished(obj)
          })
      }
    } catch (e) {
      setLoading(false)
      message.error({
        content: "C'è stato un errore nella pubblicazione del' annuncio",
        key
      })
    }
  }
  return (
    <Riepilogo
      title={!_propertyId ? 'Manca pochissimo!' : 'Modifica annuncio'}
      subtitle={
        !_propertyId ? (
          <>
            {_.size(props.formValue.images) > 1 && (
              <span>
                Controlla per un ultima volta le informazioni che hai inserito e
                pubblica il tuo annuncio.
                <br /> Se vorrai modificarlo potrai farlo accedendo alla tua
                area privata.
              </span>
            )}
            {_.size(props.formValue.images) <= 1 && (
              <span>
                Il tuo annuncio e' stato salvato, ti manca solo aggiungere delle
                foto e poi sei pronto per pubblicare!
              </span>
            )}
          </>
        ) : (
          <>
            {_.size(props.formValue.images) > 1 && (
              <span>
                In questa sezione potrai modificare o aggiungere i dettagli del
                tuo annuncio
              </span>
            )}
            {_.size(props.formValue.images) <= 1 && (
              <span>
                Il tuo annuncio e' stato salvato, ti manca solo aggiungere delle
                foto e poi sei pronto per pubblicare!
              </span>
            )}
          </>
        )
      }
    >
      {/* <Button htmlType='button' className='my-4' loading={loading} shape='round' type='primary' value='' onClick={() => onClickAnnuncio()}>Pubblica Annuncio</Button> */}
      {_.size(props.formValue.images) > 1 && (
        <RiepilogoButton
          text={!_propertyId ? 'Pubblica Annuncio' : 'Salva modifiche'}
          onClick={() => onClickAnnuncio()}
          loading={loading}
        />
      )}
      {_.size(props.formValue.images) <= 1 && (
        <RiepilogoButton
          text='Aggiungi foto'
          onClick={() => props.goToStep(4, 2)}
          loading={loading}
        />
      )}
      <Row gutter={[16, 16]}>
        <RiepilogoCard cardTitle='Costi & Regole'>
          <RiepilogoCardCosti {...props} />
        </RiepilogoCard>
        <RiepilogoCard cardTitle='Foto & Descrizione'>
          <RiepilogoCardFotoDescrizione {...props} />
        </RiepilogoCard>
        <RiepilogoCard cardTitle='Dettagli annuncio'>
          <RiepilogoCardDettagli {...props} />
        </RiepilogoCard>
      </Row>
    </Riepilogo>
  )
}

export default RiepilogoCosti
